import { Injectable, Renderer2, RendererFactory2, signal } from '@angular/core';
import { createLocalStorage } from './local-storage';

const ACCESSIBLE_FONT = 'accessibility-font';

@Injectable({
   providedIn: 'root',
})
export class AccessibilityService {
   public accessibleFont = signal(false);

   private renderer: Renderer2 = this.rendererFactory.createRenderer(null, null);
   private readonly ls = createLocalStorage<{ 'accessibility-font': boolean }>();

   constructor(private rendererFactory: RendererFactory2) {
      this.accessibleFont.set(this.ls.get(ACCESSIBLE_FONT) ?? false);
      this.enableOrDisableAccessibleFont(this.accessibleFont());
   }

   toggleAccessibleFont() {
      this.enableOrDisableAccessibleFont(!this.accessibleFont());
   }

   private enableOrDisableAccessibleFont(enable: boolean) {
      const method = enable ? 'addClass' : 'removeClass';
      this.renderer[method](document.documentElement, ACCESSIBLE_FONT);
      this.ls.set(ACCESSIBLE_FONT, enable);

      this.accessibleFont.set(enable);
   }
}
